import { useCanGoBack, useNavigate, useRouter } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

import {
  type CreateSessionParams,
  useCreateSessionMutation,
} from '~entities/session/api/create-session';

import { Button } from '~shared/shadcn/ui/button';
import { Card, CardContent } from '~shared/shadcn/ui/card';

import { SessionForm } from './session-form';

export const CreateSessionPage = () => {
  const router = useRouter();
  const navigate = useNavigate();
  const canGoBack = useCanGoBack();

  const { mutateAsync: createSession, isPending } = useCreateSessionMutation();

  const onSubmit = async (value: CreateSessionParams) => {
    try {
      await createSession(value);
      void navigate({
        to: '/sessions',
      });
      toast.success('Session created successfully.');
    } catch (error) {
      console.error('Failed to create session:', error);
      toast.error('Failed to create session. Please try again.');
    }
  };
  return (
    <div>
      <div className='mb-8 flex items-center gap-2'>
        <Button
          variant={'ghost'}
          className='flex items-center p-2 [&_svg]:size-6'
          disabled={!canGoBack}
          onClick={() => {
            router.history.back();
          }}
        >
          <CircleArrowLeft className='size-6' />
        </Button>
        <h2 className='text-2xl font-semibold'>Create new Session</h2>
      </div>
      <Card className='mx-auto w-full max-w-4xl border border-border pt-4 shadow-none'>
        <CardContent>
          <SessionForm handleSubmit={onSubmit} isPending={isPending} />
        </CardContent>
      </Card>
    </div>
  );
};
